import classNames from 'classnames';
import { forwardRef, HTMLProps, VFC } from 'react';

import styles from './CustomInput.module.scss';

type CustomInputVariant = 'primary';

type Props = HTMLProps<HTMLInputElement> & {
  variant?: CustomInputVariant;
};

const CustomInput: VFC<Props> = forwardRef(
  (
    {
      type = 'text',
      variant = 'primary',
      className,
      children,
      ...restProps
    }: Props,
    ref
  ) => {
    const classes = classNames(
      [styles.customInput, styles[variant]],
      className
    );

    return (
      <input type={type} className={classes} {...restProps} ref={ref}>
        {children}
      </input>
    );
  }
);

export default CustomInput;
